import { useProjectsStore } from '@common/modules/projects/stores'
import { useUserStore } from '@common/modules/user/stores'

import { loadWorkspaceFromStore } from './loadWorkspaceFromStore'

export function isOnboardingAlreadyComplete(): boolean {
  const user = useUserStore.getState().currentUser
  const workspace = loadWorkspaceFromStore()
  const project = useProjectsStore.getState().currentProject

  return Boolean(user && workspace && project)
}
